import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

const EscaypeDial = function(props) {
  return (
    <Image src={`/images/SkunkPotentialGraphics/${props.dialType}${props.value < 0 ? 0 : props.value}.png`} size='small' centered />
  );
};

EscaypeDial.propTypes = {
  value: PropTypes.number.isRequired,
  dialType: PropTypes.oneOf(['potential', 'skunk']).isRequired
};

export default EscaypeDial;
